// CHA1-3168: the Mastercom price row of a program card.
//
// Mastercom is a third billable lookup channel, charged since CHA1-1484, but only Consumer Clarity
// can deliver one: Ethoca sends it in `originatorChannel`, while Verifi — behind Order Insight —
// sends nothing of the kind. The backend says so by omitting `mastercom_lookup` from the Order
// Insight price block entirely rather than sending it as zero or null, so the row is driven by the
// key being there rather than by the program name. A card built from an older response, from before
// the field existed, is the same case and simply keeps its two rows.
//
// Kept out of the component so the rule can be tested: this repo has no test runner installed, so
// only plain modules can be covered (see ../../../utils/__tests__/lookupRequestScope.test.js).

/**
 * Decide whether a program card shows a Mastercom price, and with what amount.
 *
 * @param {object} [prices] The card's `prices` block as the API returned it.
 * @returns {{amount: string}|null} The row to render, or null when this program has no Mastercom price.
 */
export const mastercomPriceLine = (prices) => {
  const amount = prices?.mastercom_lookup

  if (amount === undefined || amount === null || amount === "") {
    return null
  }

  return { amount }
}
